// Moved from /nodes/node.interface.js
import { descriptors } from "../packages/descriptors.js";
import { coreEngine } from "../packages/engine.js";

class CoreNode {
  uid = undefined;
  namespace = undefined;
  coreImplementation = undefined;
  templateUid = undefined;

  props = {};

  _initialized = false;

  constructor({ uid, namespace, props = {}, coreImplementation, templateUid }) {
    this.uid = uid;
    this.namespace = namespace;
    this.templateUid = templateUid;
    this.coreImplementation = coreImplementation;
    this.props = props;

    const descriptor = descriptors.get(this.namespace);
    const propertyNames = new Set(Object.keys(descriptor.properties).filter(key => descriptor.properties[key].type !== "group"));
    const methodNames = new Set(Object.keys(descriptor.methods));

    const groupNames = new Set(Object.keys(descriptor.properties).filter(key => descriptor.properties[key].type === "group"));

    return new Proxy(this, {
      get: (target, propertyName) => {
        if (propertyNames.has(propertyName)) {
          return target.props[propertyName];
        }
        if (groupNames.has(propertyName)) {
          const prefix = propertyName + ".";
          return new Proxy({}, {
            get: (_, subProp) => target.props[prefix + subProp],
            set: (_, subProp, value) => {
              coreEngine.update({
                uid: target.uid,
                key: prefix + subProp,
                value,
              });
              return true;
            },
          });
        }
        if (methodNames.has(propertyName)) {
          return (value) => coreEngine.update({
            uid: target.uid,
            key: propertyName,
            value,
          });
        }

        return target[propertyName];
      },
      set: (target, propertyName, value) => {
        if (groupNames.has(propertyName) && typeof value === "object" && value !== null) {
          const prefix = propertyName + ".";
          for (const subProp of Object.keys(value)) {
            coreEngine.update({
              uid: target.uid,
              key: prefix + subProp,
              value: value[subProp],
            });
          }
        } else if (propertyNames.has(propertyName) || groupNames.has(propertyName)) {
          coreEngine.update({
            uid: target.uid,
            key: propertyName,
            value,
          });
        } else {
          target[propertyName] = value;
        }

        return true;
      },
    });
  }

  tell(message) {
    coreEngine.update({
      uid: this.uid,
      key: "receiveMessage",
      value: message,
    });
  }

  log(message, ...data) {
    this.coreImplementation.log(this, message, ...data);
  }

  debug(message, ...data) {
    this.coreImplementation.debug(this, message, ...data);
  }

  warn(message, ...data) {
    this.coreImplementation.warn(this, message, ...data);
  }

  error(message, ...data) {
    this.coreImplementation.error(this, message, ...data);
  }

  critical(message, ...data) {
    this.coreImplementation.critical(this, message, ...data);
  }
}

export { CoreNode };